module.exports = __webpack_public_path__ + "img/RYi.5da501da.jpeg";